"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Request = void 0;
var _eventEmitter = _interopRequireDefault(require("./event-emitter"));
var qs = _interopRequireWildcard(require("./qs"));
var _utils = require("./utils");
var _error = require("./error");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var CONTENT_TYPE_HEADER = 'Content-Type';

// the only TLS options a caller may pass, everything else (rejectUnauthorized and friends) is
// dropped on purpose so that a config blob can not weaken the connection by accident
var TLS_OPTION_KEYS = ['cert', 'key', 'passphrase', 'ca'];
var REQUEST_EVENT = 'request';
var RESPONSE_EVENT = 'response';
var ERROR_EVENT = 'error';
var DONE_EVENT = 'done';
var Request = exports.Request = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Request, _EventEmitter);
  var _super = _createSuper(Request);
  function Request(path, method, body) {
    var _this;
    _classCallCheck(this, Request);
    _this = _super.call(this);
    _this.method = method;
    _this.path = (0, _utils.ensureEncoding)(path);
    _this.body = body;
    _this.unwrap = true;
    _this.raw = false;
    _this.headers = {};
    _this.queryParams = {};
    _this.encoding = 'utf8';
    _this.timeout = 0;
    _this.withCredentials = null;

    // the private key is credential material, a non enumerable property keeps it out of
    // console.log(request)/JSON.stringify(request) in whatever logging a caller has around
    Object.defineProperty(_assertThisInitialized(_this), 'tlsOptions', {
      value: undefined,
      writable: true,
      enumerable: false,
      configurable: true
    });
    return _this;
  }

  /**
   * Sets a header
   *
   * @param {String|Object} key or map of headers
   * @param {String} [value]
   * @returns {Request}
   */
  _createClass(Request, [{
    key: "set",
    value: function set(key, value) {
      if ((0, _utils.isObject)(key)) {
        for (var headerName in key) {
          this.set(headerName, key[headerName]);
        }
      } else if (typeof value !== 'undefined') {
        this.headers[key] = value;
      }
      return this;
    }

    /**
     * Shortcut for req.set('Authorization', `Basic ${basicAuth.token}`)
     *
     * @param {Object} [basicAuth]
     * @param {String} basicAuth.token
     * @returns {Request}
     */
  }, {
    key: "basicAuth",
    value: function basicAuth(_basicAuth) {
      if (_basicAuth) {
        this.set({
          Authorization: "Basic ".concat(_basicAuth.token)
        });
      }
      return this;
    }

    /**
     * Shortcut for req.set('auth-key', authKey)
     *
     * @param {String} [authKey]
     * @returns {Request}
     */
  }, {
    key: "authKey",
    value: function authKey(_authKey) {
      if (_authKey) {
        this.set({
          'auth-key': _authKey
        });
      }
      return this;
    }

    /**
     * Attaches a TLS client certificate and private key to the request (mutual TLS).
     *
     * Works only for Node js, in a browser the client certificate is chosen by the browser itself.
     *
     * Calling the method several times merges the options, so the certificate and the key may come
     * from different places. Options other than the ones listed below are ignored.
     *
     * @param {Object} [tlsOptions]
     * @param {String|Buffer|Array} tlsOptions.cert PEM encoded client certificate (or chain)
     * @param {String|Buffer|Array} tlsOptions.key PEM encoded private key
     * @param {String} [tlsOptions.passphrase] passphrase of an encrypted private key
     * @param {String|Buffer|Array} [tlsOptions.ca] PEM encoded CA bundle to verify the server with
     * @returns {Request}
     */
  }, {
    key: "cert",
    value: function cert(tlsOptions) {
      var options = tlsOptions && pickTLSOptions(tlsOptions);
      if (options && Object.keys(options).length) {
        this.tlsOptions = _objectSpread(_objectSpread({}, this.tlsOptions), options);
      }
      return this;
    }

    /**
     * @param {Object} queryParams
     * @returns {Request}
     */
  }, {
    key: "query",
    value: function query(queryParams) {
      Object.assign(this.queryParams, queryParams);
      return this;
    }

    /**
     * Sets a multipart form as the request body.
     *
     * Accepts an instance of `Request.FormData`, a WHATWG `FormData` (the Node 18+ global one) and
     * a plain object. A Blob or a File, which the `form-data` package can not stream on its own,
     * is converted, and a value it can not send at all is reported with an error naming the field.
     *
     * @param {Object} form
     * @returns {Request}
     */
  }, {
    key: "form",
    value: function form(_form) {
      if (_form) {
        if ((0, _utils.isFormData)(_form)) {
          this.body = _form;
        } else if ((0, _utils.isWebFormData)(_form)) {
          this.body = toRequestFormData(_form);
        } else {
          var formData = new Request.FormData();
          var _loop = function _loop(formKey) {
            if (formKey) {
              (0, _utils.castArray)(_form[formKey]).forEach(function (formValue) {
                if (formValue && formValue.hasOwnProperty('value') && formValue.hasOwnProperty('options')) {
                  appendFormPart(formData, formKey, formValue.value, formValue.options);
                } else {
                  appendFormPart(formData, formKey, formValue);
                }
              });
            }
          };
          for (var formKey in _form) {
            _loop(formKey);
          }
          this.body = formData;
        }
      }
      return this;
    }

    /**
     * Shortcut for req.set('Content-Type', value)
     *
     * @param {String} contentType
     * @returns {Request}
     */
  }, {
    key: "type",
    value: function type(contentType) {
      this.set(CONTENT_TYPE_HEADER, contentType);
      return this;
    }

    /**
     * Should we unwrap the response and return only body. true by default
     * @param {Boolean} unwrap
     * @returns {Request}
     */
  }, {
    key: "unwrapBody",
    value: function unwrapBody(unwrap) {
      this.unwrap = unwrap;
      return this;
    }

    /**
     * set encoding to response
     * works only for Node js
     *
     * @param {String} encoding
     * @returns {Request}
     */
  }, {
    key: "setEncoding",
    value: function setEncoding(encoding) {
      this.encoding = encoding;
      return this;
    }

    /**
     * Sends the request and resolves the response body as raw bytes.
     *
     * Unlike `setEncoding(null)` the result is guaranteed: a `Buffer` in Node js, a `Uint8Array`
     * in a browser (a Buffer is a Uint8Array, so `instanceof Uint8Array` holds in both), an empty
     * one for a 0 byte response, and never a value that `JSON.parse` got to first.
     *
     * The method is terminal, it implies a raw transfer and overrides whatever `setEncoding` was
     * given before it, so there is no need to call `setEncoding(null)` as well.
     *
     * An unsuccessful response is rejected the same way as for any other request, with the error
     * body still JSON parsed when it is JSON - a vendor answers a failed binary download with a
     * JSON error and `error.body.message` has to keep working.
     *
     * @returns {Promise<Buffer|Uint8Array>}
     */
  }, {
    key: "toBuffer",
    value: function toBuffer() {
      this.raw = true;
      this.encoding = null;
      this.promise = this.promise || this.send(this.body);
      return this.promise;
    }

    /**
     * set withCredentials option
     *
     * @param {Boolean} value
     * @returns {Request}
     */
  }, {
    key: "setWithCredentials",
    value: function setWithCredentials(value) {
      this.withCredentials = value;
      return this;
    }

    /**
     * A number specifying request timeout in milliseconds.
     * @param {Number} ms
     * @returns {Request}
     */
  }, {
    key: "setTimeout",
    value: function setTimeout(ms) {
      this.timeout = ms;
      return this;
    }

    /**
     * Sends the request
     *
     * @param {Object} body
     * @returns {Promise}
     */
  }, {
    key: "send",
    value: function send(body) {
      var _this2 = this;
      this.emit(REQUEST_EVENT, this);
      var path = this.path;
      var queryString = qs.stringify(this.queryParams);
      if (queryString) {
        path += '?' + queryString;
      }
      if (!(0, _utils.isFormData)(body) && (0, _utils.isWebFormData)(body)) {
        body = toRequestFormData(body);
      }
      var type = this.headers[CONTENT_TYPE_HEADER];
      if (!type && (0, _utils.isObject)(body) && !(0, _utils.isFormData)(body)) {
        this.type('application/json');
      }
      if (body) {
        var isJSON = this.headers[CONTENT_TYPE_HEADER] === 'application/json';
        body = isJSON && typeof body !== 'string' ? JSON.stringify(body) : body;
      }
      var unwrapBody = function unwrapBody(res) {
        return _this2.unwrap ? res.body : res;
      };
      if (Request.verbose) {
        console.log(this.method.toUpperCase(), decodeURIComponent(path), body, this.headers);
      }
      var withCredentials = typeof this.withCredentials === 'boolean' ? this.withCredentials : Request.withCredentials;
      var syncError = new Error();
      var request = Request.send(path, this.method.toUpperCase(), this.headers, body, this.encoding, this.timeout, withCredentials, this.tlsOptions).then(function (res) {
        return parseBody(res, _this2.raw);
      }).then(function (res) {
        return ensureRawBody(res, _this2.raw);
      }).then(checkStatus).then(unwrapBody)["catch"](function (error) {
        error.stack = "".concat(error.stack).concat(syncError.stack);
        throw error;
      });
      request.then(function (result) {
        _this2.emit(RESPONSE_EVENT, result);
        _this2.emit(DONE_EVENT, null, result);
      })["catch"](function (error) {
        _this2.emit(ERROR_EVENT, error);
        _this2.emit(DONE_EVENT, error);
      });
      return request;
    }

    /**
     * If you are too lazy to use method 'send', don't use it and stay cool :)
     *
     * @param {Function} successHandler
     * @param {Function} errorHandler
     * @returns {Promise}
     */
  }, {
    key: "then",
    value: function then(successHandler, errorHandler) {
      this.promise = this.promise || this.send(this.body);
      return this.promise.then(successHandler, errorHandler);
    }

    /**
     * @param {Function} errorHandler
     * @returns {Promise}
     */
  }, {
    key: "catch",
    value: function _catch(errorHandler) {
      this.promise = this.promise || this.send(this.body);
      return this.promise["catch"](errorHandler);
    }
  }]);
  return Request;
}(_eventEmitter["default"]);
/**
 * Keeps only the known TLS options and skips the empty ones,
 * `undefined` values would otherwise overwrite already collected options on a merge
 */
function pickTLSOptions(tlsOptions) {
  var result = {};
  TLS_OPTION_KEYS.forEach(function (key) {
    if (tlsOptions[key] !== undefined && tlsOptions[key] !== null) {
      result[key] = tlsOptions[key];
    }
  });
  return result;
}

/**
 * Copies a WHATWG FormData into a `Request.FormData`.
 *
 * Iterating with `for (var key in webFormData)` , which is what a plain object gets, walks the
 * enumerable WebIDL operations of the prototype and appends `append`, `get`, `set`, `forEach` ...
 * as form parts, and streaming then calls one of them unbound
 */
function toRequestFormData(webFormData) {
  var formData = new Request.FormData();
  webFormData.forEach(function (value, key) {
    return appendFormPart(formData, key, value);
  });
  return formData;
}
function appendFormPart(formData, key, value, options) {
  if (typeof formData.getHeaders !== 'function') {
    // a browser FormData, it takes a Blob, a File and a typed array natively
    return options ? formData.append(key, value, options) : formData.append(key, value);
  }
  var part = (0, _utils.normalizeFormPart)(key, value);
  var partOptions = _objectSpread(_objectSpread({}, part.options), options);
  if (Object.keys(partOptions).length) {
    formData.append(key, part.value, partOptions);
  } else {
    formData.append(key, part.value);
  }
}
function isSuccessStatus(status) {
  return status >= 200 && status < 300;
}

/**
 * `JSON.parse` coerces its argument with `String()`, so it destroys a body that was asked for as
 * raw bytes whenever those bytes happen to be valid JSON. A raw request skips it for a successful
 * response only, an error body keeps being parsed as it always was.
 */
function parseBody(res, raw) {
  if (raw && isSuccessStatus(res.status)) {
    return res;
  }
  try {
    return _objectSpread(_objectSpread({}, res), {}, {
      body: JSON.parse(raw ? (0, _utils.decodeBytes)(res.body) : res.body)
    });
  } catch (e) {
    return res;
  }
}
function ensureRawBody(res, raw) {
  return raw && isSuccessStatus(res.status) ? _objectSpread(_objectSpread({}, res), {}, {
    body: (0, _utils.toBytes)(res.body)
  }) : res;
}

/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */
function checkStatus(response) {
  if (isSuccessStatus(response.status)) {
    return response;
  }
  throw new _error.ResponseError(response);
}